import { render, staticRenderFns } from "./CardMeasurementDetailed.vue?vue&type=template&id=fe9eeb0e"
import script from "./CardMeasurementDetailed.vue?vue&type=script&lang=js"
export * from "./CardMeasurementDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports